var rmUtil = require("../rmlibrary_old/util");
var PDFNode = require("./node");

var savedValues = {
    "total-pages": 1
};
var fieldFunctions = {
    page: function(pdf) {
        return pdf.doc.internal.getCurrentPageInfo().pageNumber;
    },
    "total-pages": function() {
        return savedValues["total-pages"];
    }
};

function PDFFieldNode(tagName, pseudo, parent, content, styles, attributes) {
    PDFNode.apply(this, arguments);

    this.fieldName = attributes.name;
}
rmUtil.inherits(PDFFieldNode, PDFNode);

PDFFieldNode.prototype.setChildren = function(children) {
    if (children.length === 0) {
        this.content = "";
    } else if (children.length === 1 && typeof children[0].content === "string") {
        this.content = children[0].content;
    } else {
        throw new TypeError("<pdf-field> can only have text content!");
    }
};

PDFFieldNode.prototype.generate = function(pdf) {
    var ret = PDFNode.prototype.generate.call(this, pdf);
    var retText = ret.text;
    var that = this;

    Object.defineProperty(ret, "text", {
        get: function() {
            try {
                var ret = fieldFunctions[that.fieldName](pdf);
                if (typeof ret === "undefined" || (!ret && typeof ret === "object")) return retText;
                return ret.toString();
            } catch (e) {
                return retText;
            }
        },
        set: function() {}
    });

    return ret;
};

PDFFieldNode.setValue = function(key, value) {
    savedValues[key] = value;
};
PDFFieldNode.getValue = function(key) {
    return savedValues[key];
};

PDFFieldNode.define = function(name, fn) {
    fieldFunctions[name] = fn;
};

module.exports = PDFFieldNode;
